import { render, staticRenderFns } from "./sendReceive.vue?vue&type=template&id=2e9fcfdf&scoped=true"
import script from "./sendReceive.vue?vue&type=script&lang=js"
export * from "./sendReceive.vue?vue&type=script&lang=js"
import style0 from "./sendReceive.vue?vue&type=style&index=0&id=2e9fcfdf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9fcfdf",
  null
  
)

export default component.exports